import { BillingErrorState } from "../../components/BillingErrorState";
import { PaymentMethodCard } from "../../components/payment-methods/components/PaymentMethodCard";
import { PaymentMethodsSkeleton } from "../../components/payment-methods/components/PaymentMethodsSkeleton";
import { usePaymentMethods } from "../../components/payment-methods/hooks/usePaymentMethods";

interface AdminPaymentMethodsTabProps {
  readonly projectId: number;
}

export function AdminPaymentMethodsTab({
  projectId,
}: AdminPaymentMethodsTabProps) {
  const { data, isError, isPending, refetch } = usePaymentMethods(projectId);

  if (isPending) {
    return <PaymentMethodsSkeleton />;
  }

  if (isError) {
    return (
      <BillingErrorState
        message="Failed to load payment methods."
        onRetry={() => refetch()}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-xl p-xl md:grid-cols-3 md:gap-3xl md:pt-3xl">
      <PaymentMethodCard
        method={data.defaultMethod}
        slot={{ kind: "default" }}
      />

      {data.backupMethods.map((method, index) => (
        <PaymentMethodCard
          key={method.id}
          method={method}
          slot={{ index, kind: "backup" }}
        />
      ))}
    </div>
  );
}
